// Conversions between the side flow's SideProduct and the ProductReference
// used by drafts, favorites and navigation state.
import { createProductReference, type ProductReference } from '../../../utils/productIdentity';
import type { SideProduct } from './reducer';

/**
 * A ready side from a reference that has a product id; `richer` (e.g. the
 * draft entry of the same product) fills in the name and image.
 */
export function sideFromReference(ref?: ProductReference, richer?: ProductReference): SideProduct | undefined {
  if (!ref?.productId) return undefined;
  const extra = richer?.productId === ref.productId ? richer : undefined;
  const name = ref.name ?? extra?.name;
  const brand = ref.brand ?? extra?.brand;
  const imageUrl = ref.imageUrl ?? extra?.imageUrl ?? undefined;
  return {
    productId: ref.productId,
    name: name ?? brand ?? `Product #${ref.productId}`,
    ...(brand && name ? { brand } : {}),
    ...(imageUrl ? { imageUrl } : {}),
    verified: false,
  };
}

/** The barcode of a reference that has no product id yet (identified on demand). */
export function pendingBarcode(ref?: ProductReference): string | undefined {
  return ref && !ref.productId && ref.barcode ? ref.barcode : undefined;
}

/** What a draft keeps of a ready side: id, name and image (no scan session). */
export function referenceFromSide(product: SideProduct | null): ProductReference | undefined {
  if (!product) return undefined;
  return createProductReference({
    productId: product.productId,
    name: product.name,
    brand: product.brand,
    ...(product.imageUrl ? { imageUrl: product.imageUrl } : {}),
  });
}
